<template>
    <div class="md-layout md-alignment-center-center">
        <div class="md-layout-item registerContainer">
            <md-card class="registerCard">
                <md-card-header class="md-title">Register</md-card-header>
                <md-card-content>
                    <p class="registerText">To register for an account, please fill out the following, or return to <router-link to="/login">login.</router-link></p>
                    <md-field>
                        <label>User Name</label>
                        <md-input type="text" v-model.trim="name"></md-input>
                        <span class="md-helper-text">Username needs to be at least 3 characters.</span>
                    </md-field>
                    <md-field>
                        <label>Email address</label>
                        <md-input type="text" v-model.trim="email"></md-input>
                    </md-field>
                    <md-field>
                        <label>Password</label>
                        <md-input type="password"></md-input>
                    </md-field>
                    <md-field>
                        <label>Confirm Password</label>
                        <md-input type="password" v-model.trim="password"></md-input>
                    </md-field>
                </md-card-content>
                <md-card-actions>
                    <md-button class="md-dense md-accent" @click="register()">Register</md-button>
                </md-card-actions>
            </md-card>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'

const fb = require('../config.js')

export default {
  name: 'appRegister',
  data: function () {
    return {
      name: '',
      email: '',
      password: ''
    }
  },
  methods: {
    ...mapActions(['displayError', 'displayMessage']),
    register: function () {
      if (this.name.length > 2) {
        fb.auth.createUserWithEmailAndPassword(this.email, this.password).then(user => {
          user.user.updateProfile({
            displayName: this.name
          }).then(function () {
            this.displayMessage('Registration successful')
          }).catch(function (err) {
            this.displayError('Error registering: ' + err.message)
          })
        }).catch(function (err) {
          this.displayError('Error registering: ' + err.message)
        })
      } else {
        this.displayError('Username needs to be at least 3 characters.')
      }
    }
  }
}
</script>

<style lang="scss">
  .registerContainer
  {
    max-width: 332px;
  }
  .registerCard {
    max-width: 300px;
  }
  .registerCard svg {
    fill: #ff9800 !important;
  }
</style>
